import React from 'react';
import './Home.css';
import  euphron from '../../assets/euphron.png';
import Drawer from "../../components/drawer/Drawer";

function Home() {
    return (
        <main id={'container'}>
            <h3>Outils d'optimisation de scéance</h3>
            <img src={euphron} alt={'logo'}/>
            <Drawer />
        </main>
    );
};

export default Home;